import { parseNoteHtml, mergeRuns } from './parseNoteHtml';
import { serializeBlocks } from './serializeBlocks';

const textRuns = (blocks) => blocks.flatMap((b) => b.runs).filter((r) => r.text !== '');

export const isStyleOnAll = (text, style) => {
    const runs = textRuns(parseNoteHtml(text));
    return runs.length > 0 && runs.every((r) => r[style]);
};

export const toggleStyleAll = (text, style) => {
    const blocks = parseNoteHtml(text);
    const runs = textRuns(blocks);
    if (!runs.length) return text;
    const removeIt = runs.every((r) => r[style]);
    const next = blocks.map((block) => ({
        ...block,
        runs: mergeRuns(block.runs.map((run) => {
            const copy = { ...run };
            if (removeIt) delete copy[style]; else if (copy.text !== '') copy[style] = true;
            return copy;
        })),
    }));
    return serializeBlocks(next);
};

export const isListAll = (text, kind) => {
    const blocks = parseNoteHtml(text);
    const nonEmpty = blocks.filter((b) => b.runs.some((r) => r.text !== ''));
    return nonEmpty.length > 0 && nonEmpty.every((b) => b.type === kind);
};

export const toggleListAll = (text, kind) => {
    const blocks = parseNoteHtml(text);
    if (!textRuns(blocks).length) return text;
    const removeIt = isListAll(text, kind);
    const next = blocks.map((b) => ({ ...b, type: removeIt ? 'paragraph' : kind }));
    return serializeBlocks(next);
};
